import 'Assets/styles/default/pages/focalPoint/FocalPointManagePointsStyles.less';
import React, { useEffect, useState } from 'react';
import {
    VertModal,
    VertButton,
    Typography,
    VertInput,
    message
} from '@vertem-core/vertice-ds';
import { Col, Form, Row } from 'antd';
import { pointsMask } from 'Utils/commons/points';
import MaskedInput from 'pages/newSolicitation/components/InputMask';
import { useDispatch, useSelector } from 'react-redux';
import { getParticipantByDocumentThunk, resetDataGetParticipantByDocument } from '../../../redux/Reducers/FocalPoint/getParticipantByDocumentSlicer';
import { cpf } from 'cpf-cnpj-validator';

const EditParticipantModal = ({ isOpen, onClose, participantToEdit, editParticipant, remainingPoints, pointsName, decimalPlaces, listDocument }) => {

    const [form] = Form.useForm();
    const [participantExists, setParticipantExists] = useState(false);
    const dispatch = useDispatch();

    const {
        dataGetParticipantByDocument,
        loadingGetParticipantByDocument,
        errorGetParticipantByDocument,
    } = useSelector(
        (state) => state.GetParticipantByDocument
    );

    const handleEditParticipant = () => {
        form.validateFields().then((participant) => {

            if (listDocument.some(a => a.cpf == participant.document)) {
                message.error("Já existe um participante com esse CPF nessa solicitação!");
                return;
            }

            participant.value = parseFloat(participant.value.replace(',', '.'));
            participant.id = participantToEdit.id;
            participant.participantExists = participantExists;
            dispatch(resetDataGetParticipantByDocument());
            editParticipant(participant);
            form.resetFields();
        });
    }

    const remainingPointsWhileEditing = () => {
        return remainingPoints + participantToEdit.points;
    }

    const handleConvertPointTemp = () => {

        var unitValueString = form.getFieldValue('value');

        if (!unitValueString)
            return;

        var splitComma = unitValueString.split(',');

        if (!splitComma[1] || splitComma[1].length !== 2) {
            if (splitComma.length === 1) {
                splitComma.push('00');
            }
            else {
                splitComma[1] = splitComma[1].length === 1 ? splitComma[1] + '0' : '00';
            }
        }

        var unitValueDecimal = splitComma.join('.');
        form.setFieldValue('value', unitValueDecimal.replace('.', ','));
    }

    const validateValue = (fieldName) => {

        var fieldValue = form.getFieldValue(fieldName.field);

        if (!fieldValue)
            return Promise.resolve();

        var unitValue = parseFloat(fieldValue.replace(',', '.'));

        if (unitValue > (remainingPointsWhileEditing())) {
            return Promise.reject(new Error(`Valor informado é maior que o disponível para distribuição`));
        }
        return Promise.resolve();
    };

    const validateConfirmValue = (fieldName) => {

        var confirmEmailValue = form.getFieldValue(fieldName.field);
        var emailValue = form.getFieldValue('email');

        if (confirmEmailValue != emailValue) {
            return Promise.reject(new Error(`Os endereços de e-mail não coincidem`));
        }
        return Promise.resolve();
    };

    const handleDocumentBlur = (document) => {
        if (document.length != 11) return;

        setParticipantExists(true);
        dispatch(getParticipantByDocumentThunk(document));
    }

    useEffect(() => {
        if (participantToEdit.id) {
            form.setFieldsValue(
                {
                    name: participantToEdit.name,
                    document: participantToEdit.cpf,
                    email: participantToEdit.email,
                    confirmEmail: participantToEdit.email,
                    value: `${participantToEdit.points}`.replace('.', ',')
                }
            )
            setParticipantExists(participantToEdit.participantExists);
        }
    }, [participantToEdit]);

    useEffect(() => {
        if (dataGetParticipantByDocument?.id && isOpen) {
            form.setFieldsValue(
                {
                    name: dataGetParticipantByDocument.name,
                    email: dataGetParticipantByDocument.email,
                    confirmEmail: dataGetParticipantByDocument.email
                }
            )
        }
    }, [dataGetParticipantByDocument]);

    useEffect(() => {
        if (errorGetParticipantByDocument) {
            setParticipantExists(false);
            dispatch(resetDataGetParticipantByDocument());
        }
    }, [errorGetParticipantByDocument]);

    return (
        <VertModal
            destroyOnClose={true}
            open={isOpen}
            onCancel={() => {
                dispatch(resetDataGetParticipantByDocument());
                form.resetFields();
                onClose();
            }}
            className="container-modal-focal-point-manage"

            width={'80%'}
            title={
                <>
                    Editar participante
                </>
            }
        >
            <Form
                className='form-add-participant'
                form={form}
                onFinish={() => { handleEditParticipant() }}
            >

                <Row gutter={[16, 16]}>

                    <Col span={8}>
                        <Form.Item
                            name="document"
                            validateTrigger={['onBlur']}
                            rules={[
                                {
                                    required: true,
                                    message: 'CPF precisa ser preenchido.'
                                },
                                {
                                    pattern: /^[0-9]{3}\.?[0-9]{3}\.?[0-9]{3}\-?[0-9]{2}$/g,
                                    validator: (_, value) => {
                                        if (value && !cpf.isValid(value)) {
                                            return Promise.reject(new Error('CPF inválido.'));
                                        }
                                        return Promise.resolve();
                                    },
                                    message: 'CPF inválido.',
                                },
                            ]}>
                            <MaskedInput
                                mask={'999.999.999-99'}
                                label="CPF"
                                template="marketplace"
                                onBlur={event => {
                                    handleDocumentBlur(event?.target?.value.replace(/[^0-9]/g, ''));
                                }}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={24}>
                        <Form.Item
                            name="name"
                            validateTrigger={['onBlur']}
                            rules={[
                                {
                                    required: true,
                                    message: 'Nome completo precisa ser preenchido.'
                                },
                                {
                                    max: 50,
                                    message: 'Excedeu o limite de caracteres, o máximo permitido é 50.'
                                },
                            ]}>
                            <VertInput
                                disabled={participantExists || loadingGetParticipantByDocument}
                                label="Nome completo"
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            name="email"
                            validateTrigger={['onBlur']}
                            rules={[
                                {
                                    required: true,
                                    message: 'E-mail precisa ser preenchido.'
                                },
                                {
                                    type: 'email',
                                    message: 'Email inválido.',
                                },
                            ]}>
                            <VertInput
                                disabled={participantExists || loadingGetParticipantByDocument}
                                label="E-mail"
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            name="confirmEmail"
                            validateTrigger={['onBlur']}
                            rules={[
                                {
                                    required: true,
                                    message: 'Confirmar e-mail precisa ser preenchido.'
                                },
                                {
                                    type: 'email',
                                    message: 'Email inválido.',
                                },
                                {
                                    validator: value => validateConfirmValue(value)
                                }
                            ]}>
                            <VertInput
                                disabled={participantExists || loadingGetParticipantByDocument}
                                label="Confirmar e-mail"
                            />
                        </Form.Item>
                    </Col>

                    <Col span={24}>

                        <Row>

                            <Col span={24}>

                                <Typography.Text className="modal-allocate-point-text-main">
                                    Valor a distribuir
                                </Typography.Text>

                            </Col>

                            <Col span={24}>

                                <Typography.Text className="modal-allocate-point-text-sub">
                                    O valor disponível para distribuir é de {pointsMask(remainingPointsWhileEditing(), decimalPlaces, pointsName).value} {pointsName}
                                </Typography.Text>
                            </Col>

                        </Row>

                    </Col>

                    <Col span={12}>

                        <Form.Item
                            name="value"
                            validateTrigger={['onBlur']}
                            rules={[
                                {
                                    required: true,
                                    message: 'Valor para distribuição precisa ser preenchido.'
                                },
                                {
                                    validator: value => validateValue(value)
                                }
                            ]}>
                            <VertInput
                                label="Valor para distribuição R$"
                                onBlur={() => handleConvertPointTemp()}
                                mask={/^[\d]+[,]?[\d]{0,2}$/i}
                            />
                        </Form.Item>

                    </Col>

                    <Col span={24}>

                        <Row justify={'end'}>
                            <Col span={6}>
                                <VertButton
                                    htmlType="submit"
                                    type="highlight"
                                    size="default"
                                    className='button-historic-redirect button-focal-point width-100'
                                    disabled={loadingGetParticipantByDocument}
                                >
                                    Salvar
                                </VertButton>
                            </Col>
                        </Row>

                    </Col>

                </Row>

            </Form>

        </VertModal >
    );
};

export default EditParticipantModal;
